/**
 * NovelMello 品牌 - Home 页面配置
 *
 * 说明:此文件只放颜色/渐变/开关。
 * UnoCSS 不扫描 .ts,原子类名一律写在 .vue 中。
 */
import type { HomePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'
import { t } from '@/i18n/utils'

/** pink 主色 */
const PINK = brandTheme.primaryColor || '#F0509B'
/** purple 辅主色 */
const PURPLE = '#7C4DE8'
/** ink-3 */
const INK_3 = brandTheme.textTertiary || '#AB9BB8'
/** 主渐变 */
const PRIMARY_GRADIENT = brandTheme.primaryGradient || `linear-gradient(90deg, ${PINK} 0%, #9B5CF0 100%)`

export const theme = {
  // 不使用装饰背景图,页面底色由品牌 bgGlobal(#FBF6FB)承接
  homeBg: '',
  tagsBg: '',

  // 标签(2×3 栏目用,后台若配置也不会破样式)
  tagActiveBg: PINK,
  tagActiveText: brandTheme.textInverse || '#FFFFFF',
  tagInactiveBg: '#FDEFF6',
  tagInactiveText: PINK,
  commonTagText: PINK,

  // —— sticky-header 滚动后(show-bg)态 ——
  stickyHeaderBg: brandTheme.bgGlobal || '#FBF6FB',
  tabActiveColor: PINK,
  tabActiveGradient: PRIMARY_GRADIENT,
  primaryGradient: PRIMARY_GRADIENT,
  showTabUnderline: false, // 用 18×3 的 active-bar,不用长下划线

  // —— sticky-header 叠在 banner 上(on-banner)态 ——
  onBannerTabActiveColor: '#FFFFFF',
  onBannerTabInactiveColor: 'rgba(255, 255, 255, 0.7)',
  onBannerSearchBg: 'rgba(255, 255, 255, 0.18)',
  onBannerSearchPlaceholderColor: 'rgba(255, 255, 255, 0.9)',
  tabActiveFontWeight: '800',

  // —— 顶部 Banner ——
  topBannerRadius: '20px',
  topBannerBottomGradient: 'linear-gradient(180deg, rgba(29, 18, 51, 0) 0%, rgba(29, 18, 51, 0.8) 100%)',
  topBannerBottomMaskHeight: '132px',
  topBannerShowText: true,
  topBannerIndicatorActiveColor: PINK,

  // —— Most Popular 排名数字色:第1 / 第2 / 第3及以后 ——
  rankingNumberColors: [PINK, PURPLE, INK_3],
} as const

export const homeConfig: HomePageConfig = {
  theme,
  // 与 common.ts 同结构,仅覆盖两条文案(保持 getter 以支持运行时切语言)
  texts: {
    get searchPlaceholder() { return t('SearchStoriesAuthors') },
    get seeAll() { return t('More') },
    get loading() { return `${t('Loading')}...` },
    get noMore() { return `${t('NoMore')} ~` },
  },
}
